/* @flow */
import React from 'react';

import { saleLabel } from './messages';

// Component
import { PriceLabel } from './PriceLabel';
import { textPercentageOff } from '../helpers/priceTypeConstants';

// Styles
import styles from './styles.scss';

type SaleProps = {|
    currency: string,
    percentageOff: ?number,
    price: number,
    quantityDisplay?: string,
    showPriceVariability: boolean,
    isTestVariant?: boolean,
|};

export function Sale({
    percentageOff,
    price,
    quantityDisplay,
    currency,
    showPriceVariability,
    isTestVariant,
}: SaleProps) {
    return (
        <React.Fragment>
            <PriceLabel
                price={price}
                label={percentageOff ? saleLabel : ''}
                quantityDisplay={quantityDisplay}
                currency={currency}
                showPriceVariability={showPriceVariability}
            />
            {percentageOff ? (
                <div
                    className={`${styles.percentageOff} ${styles.sale} ${
                        isTestVariant ? styles.testVariant : ''
                    }`}
                    data-tn="discount-amount"
                >
                    {textPercentageOff(percentageOff)}
                </div>
            ) : null}
        </React.Fragment>
    );
}

Sale.defaultProps = {
    percentageOff: null,
    showPriceVariability: false,
};
